import { HotelSearchContextSelector } from '@frontend/features/hotels/HotelSearchContextSelector';

export const Hotels = () => <HotelSearchContextSelector />;
